import { Portal } from '@blueprintjs/core';
import * as React from 'react';

import { CompetencyQuestionsPanel } from 'src/containers/CreateProjectOverlay/CompetencyQuestionsPanel';
import { CreateProjectSteps } from 'src/containers/CreateProjectOverlay/CreateProjectSteps';
import {
  CreateProjectContext,
  CreateProjectStepValue,
  useCreateProjectStateValue,
} from 'src/containers/CreateProjectOverlay/hooks/useCreateProjectState';
import { ProjectScopingPanel } from 'src/containers/CreateProjectOverlay/ProjectScopingPanel';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

const CreateProjectOverlayBody: React.VFC = () => {
  const state = useCreateProjectStateValue();
  return (
    <CreateProjectContext.Provider value={state}>
      <div className="sd-create-project-overlay">
        <div className="sd-create-project-panel">
          <CreateProjectSteps />

          <div className="sd-create-project-panel-background">
            <div className="sd-create-project-panel-body">
              {state.currentStep === CreateProjectStepValue.PROJECT_SCOPING ? (
                <ProjectScopingPanel />
              ) : null}
              {state.currentStep ===
              CreateProjectStepValue.COMPETENCY_QUESTIONS ? (
                <CompetencyQuestionsPanel />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </CreateProjectContext.Provider>
  );
};

export const CreateProjectOverlay: React.VFC = () => {
  const isOpen = useReduxSelector(
    (state) => state.ui.isCreateProjectOverlayOpen
  );

  return (
    <Portal className="sd-create-project-portal">
      {isOpen ? <CreateProjectOverlayBody /> : null}
    </Portal>
  );
};
